// src/cert/halal.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const Halal = () => {
  return (
    <div className="cert-page">
      <div className="cert-header">
        <h1>Halal प्रमाणन</h1>
        <p>इस्लामिक अन्न सुरक्षा मानक (Islamic Food Safety Standard)</p>
      </div>

      <div className="cert-content">
        <section>
          <h2>Halal म्हणजे काय?</h2>
          <p>
            Halal is an Arabic word that implies admissible. A Halal Certified item means that the item is admissible or satisfactory as per Islamic law. With the goal for items to get this Certification. They should be from a worthy source, for example, dairy animals or chicken and butchered by these laws.

            Halal exchange alludes to the business of HALAL-guaranteed quality items that meet the globally acknowledged sanitation measures underway and cleanliness.

            SIS has strategic tie-ups with different HALAL certification agencies (Indian & overseas) to provide HALAL certification services in India. These associations are distinctive ISLAMIC religious associations and they issue HALAL authentication following the rules of The Quran. The HALAL audit is done by a Maulana who should have proper knowledge of the Quran & ISLAM.
          </p>
        </section>

        <section>
          <h2>प्रमुख फायदे</h2>
          <ul>
            <li>मुस्लिम ग्राहकांचा विश्वास मिळवतो (2 बिलियन+ लोकसंख्या)</li>
            <li>मलेशिया, इंडोनेशिया, UAE, सौदी अरेबिया, भारतात निर्यात</li>
            <li>अन्न शुद्धता, स्वच्छता, ट्रेसेबिलिटी सुनिश्चित होते</li>
            <li>हलाल लोगो — ब्रँड मूल्य वाढते</li>
            <li>अन्न सुरक्षा आणि गुणवत्ता (HACCP सोबत सुसंगत)</li>
          </ul>
        </section>

        <section className="apply-section">
          <h2>Halal प्रमाणनासाठी अर्ज करा</h2>
          <ApplyForm certification="Halal" />
        </section>
      </div>
    </div>
  );
};

export default Halal;